import Container from '@/components/atoms/Container'
import Spinner from '@/components/atoms/Spinner'
import cohortsService from '@/services/cohortsService'
import typeformService from '@/services/typeformService'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import utc from 'dayjs/plugin/utc.js'
import { useAppSelector } from '@/store/hooks'

dayjs.extend(utc)
dayjs.locale('pt-br')

export function Body() {
	const {
		matriculate: { classSelect },
	} = useAppSelector((state) => state)

	const navigate = useNavigate()
	const [loading, setLoading] = useState(false)

	const { data: progressCheckData, isLoading } =
		cohortsService.getProgressChecks()

	const {
		execute: getResultTypeform,
		data,
		isLoading: isLoadingGetResult,
		isSuccess,
		isError,
	} = typeformService.getResultMutation()

	const {
		execute: saveProgressCheckAttempts,
		isLoading: isLoadingAttempts,
		isSuccess: isSuccessAttempts,
		isError: isErrorAttempts,
	} = cohortsService.saveProgressCheckAttempts()

	const findProgress = progressCheckData?.progressChecks?.find(
		(progress) => progress?.turma_id === classSelect?.id
	)

	const findTypeform = findProgress?.link?.split('/')?.pop()

	useEffect(() => {
		if (findTypeform) {
			const handleFormSubmit = async ({
				formId,
				responseId,
			}: {
				formId: string
				responseId: string
			}) => {
				if (responseId) {
					setLoading(true)
					await new Promise((resolve) => setTimeout(resolve, 10000))
					await getResultTypeform({ formId, responseId })
				}
			}

			window.submit = handleFormSubmit

			const script = document.createElement('script')
			script.src = 'https://embed.typeform.com/next/embed.js'
			script.async = true

			document.body.appendChild(script)

			return () => {
				document.body.removeChild(script)
				delete window.submit
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [findTypeform])

	useEffect(() => {
		if (isSuccess && data?.variables) {
			const score = data?.variables?.find(
				(item: { key: string }) => item.key === 'score'
			)?.number

			const totalChoices = data?.answers?.filter(
				(item) => item.type === 'choice'
			).length

			const percentage = (Number(score) / Number(totalChoices)) * 100

			const progressCheckId = findProgress?.id
			const nota = Math.round(percentage) || 0

			if (progressCheckId) {
				const formResult = {
					progress_check_id: progressCheckId,
					data_tentativa: dayjs().endOf('day').format('YYYY-MM-DD'),
					nota,
				}

				saveProgressCheckAttempts(formResult)
			} else {
				navigate('/curso')
			}
		}

		if (isError || isErrorAttempts) navigate('/curso')
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSuccess, data])

	useEffect(() => {
		if (isSuccessAttempts) {
			navigate('/curso/progress-check')
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSuccessAttempts])

	if (loading || isLoadingGetResult || isLoadingAttempts) {
		return (
			<Container className='flex flex-col items-center justify-center min-h-[65vh] gap-8 lg:gap-12 z-20'>
				<Spinner
					className={
						'inline w-12 h-12 md:w-14 md:h-14 text-gray-200/20 animate-spin fill-brand-primary'
					}
				/>
				<p className='text-3xl md:text-4xl lg:text-[40px] text-white font-semibold text-center w-full max-w-[465px] leading-[120%]'>
					Carregando o resultado do teste
				</p>
			</Container>
		)
	}

	if (!isLoading) {
		const endDate = dayjs(findProgress?.data_final).endOf('day')
		const isPast = dayjs().endOf('day').isAfter(endDate)
		const nextSubmitLimitStart = findProgress?.data_ultimo_envio
			? dayjs(findProgress?.data_ultimo_envio).endOf('day').add(1, 'days')
			: undefined

		const notStart = dayjs()
			.endOf('day')
			.isBefore(dayjs(findProgress?.data_inicio).endOf('day'))

		if (isPast || notStart) navigate('/curso')

		if (
			!dayjs().isSame(dayjs(nextSubmitLimitStart).endOf('day'), 'day') &&
			!dayjs().isAfter(dayjs(nextSubmitLimitStart).endOf('day'), 'day')
		) {
			navigate('/curso/progress-check')
		}
	}

	return (
		<Container className='flex flex-col items-center justify-center gap-12 py-2 pb-10'>
			<div className='flex flex-col justify-center items-center gap-2'>
				<p className='text-white/90 w-full max-w-[578px] text-center'>
					Progress Check
				</p>
				<h1 className='text-4xl text-white font-bold leading-[120%] relative text-center z-10'>
					{findProgress?.nome}
				</h1>
			</div>

			{(() => {
				if (isLoading) {
					return (
						<div className='flex justify-center'>
							<Spinner
								className={
									'inline w-10 h-10 text-gray-200 animate-spin fill-brand-primary'
								}
							/>
						</div>
					)
				}

				if (!findProgress) {
					return (
						<Container>
							<div className='w-full h-max py-4 px-4 flex items-start justify-center bg-[#191122] border border-dashed border-white/10 rounded-xl'>
								<p className='text-base text-white font-medium md:text-center'>
									Nenhum Progress Check disponível no momento
								</p>
							</div>
						</Container>
					)
				}

				return (
					<div
						data-tf-widget={findTypeform}
						data-tf-on-submit='submit'
						data-tf-on-ending-button-click=''
						className='w-full max-w-screen-lg h-screen max-h-[650px] z-20'
					></div>
				)
			})()}
		</Container>
	)
}
